import { render } from "./CardsManagement.vue?vue&type=template&id=55ffa7da&scoped=true"
import script from "./CardsManagement.vue?vue&type=script&lang=js"
export * from "./CardsManagement.vue?vue&type=script&lang=js"

import "./CardsManagement.vue?vue&type=style&index=0&id=55ffa7da&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ffa7da"]])

export default __exports__